export default __webpack_public_path__ + "static/media/home.7fb19fde.png";